export enum AppRouters {
  noExist = '#',

  login = '/login',
  register = '/register',
  forgotPassword = '/forgot-password',

  home = '/',
  municipality = '/municipality',

  profile = '/profile',

  projectAnalysis = '/project-analysis',
  projectAnalysisAdmin = '/admin/project-analysis',
  projectAnalysisAdminNew = '/admin/project-analysis/new',

  admin = '/admin',
  translatePanel = '/admin/translate-panel',
  planManagement = '/admin/plan-management',
  chatKnowledge = '/admin/chat-knowledge',
  chat = '/admin/chat',
  users = '/admin/users',
  bigQuerySyncPreview = '/admin/bigquery-sync-preview',
}
